import type { Doc } from "building-types/doc";
import type { GroupableEntityHandle, GroupHandle } from "building-types/handles/docEntityHandleTypes";
import type { GroupableEntity } from "./docEntityGroupable";
import docGetEntity from "./docGetEntity";
import { docGetGroupEntities } from "./docGetHashTableEntities";
import { groupableAndSortableEntityTypes } from "./entityGroupTools";

/**
 * @param sort Sorts by doc table sortIndex if entity type is sortable.
 */
export function docGetGroupImmediateChildren(
  doc: Doc,
  handle: GroupHandle,
  sort: boolean = false,
): GroupableEntityHandle[] {
  const entityHandles = docGetGroupEntities(doc, handle);
  if (!sort) {
    return entityHandles;
  }

  let sortable = true;
  const entitiesByHandle = new Map<GroupableEntityHandle, GroupableEntity>();

  for (const childHandle of entityHandles) {
    const groupableAndSortablePredicate = groupableAndSortableEntityTypes[childHandle.type];
    const entity = docGetEntity(doc, childHandle) as GroupableEntity;
    let groupableAndSortable = false;

    if (typeof groupableAndSortablePredicate === "function") {
      groupableAndSortable = groupableAndSortablePredicate(entity);
    } else {
      groupableAndSortable = groupableAndSortablePredicate;
    }

    if (!groupableAndSortable) {
      sortable = false;
    }

    entitiesByHandle.set(childHandle, entity);
  }

  if (sortable) {
    entityHandles.sort((a, b) => {
      const entityA = entitiesByHandle.get(a);
      const entityB = entitiesByHandle.get(b);

      if (!entityA || !entityB) {
        return 0;
      }

      return entityA.sortIndex - entityB.sortIndex;
    });
  }

  return entityHandles;
}
